import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=0ff57f24&scoped=true&functional=true"
import script from "./SectionTitle.vue?vue&type=script&lang=ts"
export * from "./SectionTitle.vue?vue&type=script&lang=ts"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=0ff57f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0ff57f24",
  null
  
)

export default component.exports